import React from "react";

// Shimmering skeleton block
export function SkeletonBlock({ className = "" }) {
  return <div className={`skeleton-shimmer rounded-xl ${className}`} />;
}

// A tree-shaped skeleton shown while the family loads — mirrors the real card layout.
export function TreeSkeleton() {
  const Card = ({ style }) => (
    <div className="flex w-[180px] flex-col items-center rounded-2xl border-2 border-[#E2E9EF] bg-white px-4 py-4 shadow-sm" style={style}>
      <div className="skeleton-shimmer mb-3 h-[68px] w-[68px] rounded-full" />
      <div className="skeleton-shimmer h-3.5 w-28 rounded" />
      <div className="skeleton-shimmer mt-2 h-2.5 w-16 rounded" />
    </div>
  );
  return (
    <div className="flex h-full w-full items-center justify-center overflow-hidden" data-testid="tree-skeleton">
      <div className="flex flex-col items-center gap-16">
        <div className="flex items-center gap-16">
          <Card /><Card />
        </div>
        <div className="flex items-center gap-10">
          <Card /><Card /><Card />
        </div>
      </div>
    </div>
  );
}

// A generic stacked-row skeleton for lists / panels.
export function ListSkeleton({ rows = 6 }) {
  return (
    <div className="space-y-3" data-testid="list-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={`sk-row-${i}`} className="flex items-center gap-3 rounded-xl border border-[#E2E9EF] bg-white p-3">
          <div className="skeleton-shimmer h-11 w-11 shrink-0 rounded-full" />
          <div className="flex-1 space-y-2">
            <div className="skeleton-shimmer h-3.5 w-1/3 rounded" />
            <div className="skeleton-shimmer h-2.5 w-1/4 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

// A masonry-ish photo grid skeleton.
export function GallerySkeleton({ count = 9 }) {
  const heights = [180, 140, 220, 160, 200, 150, 190, 170, 210];
  return (
    <div className="columns-2 gap-3 sm:columns-3 lg:columns-4" data-testid="gallery-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={`sk-ph-${i}`} className="skeleton-shimmer mb-3 w-full rounded-xl" style={{ height: heights[i % heights.length] }} />
      ))}
    </div>
  );
}
